module.exports = __webpack_public_path__ + "img/autohuh-original-960.9546323b.png";